module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="sample-chart ' +
((__t = ( data.activeType )) == null ? '' : __t) +
' ' +
((__t = ( data.pivotClass )) == null ? '' : __t) +
'"></div>\n<div>\n    <div class="widget-dimensions">\n        <header>Dimensions</header>\n        ';
 if (data.multiPivot) { ;
__p += '\n\n        <div>\n            <div class="dimlabel">Tabs</div>\n            <div class="tabs-dimension" data-sample="tabs"></div>\n        </div>\n\n        ';
 } ;
__p += '\n        <div>\n            <div class="dimlabel">' +
((__t = ( data.pivotLabel )) == null ? '' : __t) +
'</div>\n            <div class="charts-dimension" data-sample="chart"></div>\n        </div>\n    </div>\n\n    <div class="widget-values-by ' +
((__t = ( data.activeType )) == null ? '' : __t) +
' ' +
((__t = ( data.hideActiveType )) == null ? '' : __t) +
'">\n        <header>Values to chart</header>\n        <div class="choice">\n            <input type="radio" name="value-by" value="amount" ' +
((__t = ( data.byAmount )) == null ? '' : __t) +
'> by amount <br>\n            <input type="radio" name="value-by" value="count" ' +
((__t = ( data.byCount )) == null ? '' : __t) +
'> by count\n        </div>\n        <div class="both">\n            <input type="checkbox" name="value-by" value="amount" checked disabled> by amount <br>\n            <input type="checkbox" name="value-by" value="count" checked disabled> by count\n        </div>\n    </div>\n</div>\n';
return __p
}